import React from "react";
import images from "components/images";

const Github = () => (
  <a
    href="https://github.com/CombinedArmsGaming"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img src={images["Github"]} width="96" height="96" alt={"Github"} />
  </a>
);

export default Github;
